import { auxiliaryStorage } from "./auxiliaryStorage";
import type { ReactNode } from "react";
import { catalogData } from "@hanjan-shieo/content";
import { channel, channelApiUrl } from "./channel";
export { channel } from "./channel";
export type { Channel } from "./channel";

export function navigate(path: string) {
  if (typeof history === "undefined") return;
  history.pushState({ hsDepth: Number(history.state?.hsDepth ?? 0) + 1 }, "", path);
  dispatchEvent(new PopStateEvent("popstate"));
  scrollTo({ top: 0, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  requestAnimationFrame(() => document.querySelector<HTMLElement>("main")?.focus());
}

export function Link({ href, children, className = "" }: { href: string; children: ReactNode; className?: string }) {
  const current = typeof location !== "undefined" && (location.pathname === href || (href !== "/" && location.pathname.startsWith(`${href}/`)));
  return <a href={href} className={className} aria-current={current ? "page" : undefined} onClick={(event) => { if (!event.metaKey && !event.ctrlKey) { event.preventDefault(); navigate(href); } }}>{children}</a>;
}

type HapticRuntime = { storage: Pick<Storage, "getItem">; vibrate: ((pattern: number | number[]) => boolean) | undefined; now: () => number; hidden: () => boolean };
export function createHaptic(runtime: HapticRuntime) {
  let lastAt = -Infinity;
  return (kind: "light" | "medium" | "success") => {
    const now = runtime.now();
    if (runtime.storage.getItem("hs-haptics") === "off" || runtime.storage.getItem("hs-reduced-sensory") === "on" || runtime.hidden() || now - lastAt < 150) return false;
    lastAt = now;
    return runtime.vibrate?.(kind === "light" ? 10 : kind === "medium" ? 20 : [10, 40, 20]) ?? false;
  };
}
let channelVibrate: ((pattern: number | number[]) => boolean) | undefined;
export function installChannelHaptic(vibrate: (pattern: number | number[]) => boolean) { channelVibrate = vibrate; }
export const haptic = createHaptic({ storage: auxiliaryStorage, vibrate: (pattern) => channelVibrate?.(pattern) ?? (typeof navigator === "undefined" ? false : navigator.vibrate?.(pattern) ?? false), now: () => typeof performance === "undefined" ? Date.now() : performance.now(), hidden: () => typeof document !== "undefined" && document.hidden });

const allowedProps = new Set(["productId","channel","buildVersion","catalogVersion","canonicalId","playability","partySizeBand","elapsedMs","gamesCompleted","restsCompleted","durationMs","source","resultCount","intent","qualifiedCount","nearbyCount","providerMode"]);
export function track(name: string, props: Record<string, string | number | boolean> = {}) {
  if (typeof navigator === "undefined") return;
  const safeProps = Object.fromEntries(Object.entries(props).filter(([key]) => allowedProps.has(key)));
  const event = { id: crypto.randomUUID(), name, occurredAt: new Date().toISOString(), props: { productId: "hanjan-shieo", channel, buildVersion: import.meta.env.VITE_BUILD_VERSION ?? "local", catalogVersion: catalogData.catalogVersion, ...safeProps } };
  const body = JSON.stringify({ events: [event] });
  if (navigator.sendBeacon) navigator.sendBeacon(channelApiUrl("/api/v1/analytics/batch"), new Blob([body], { type: "application/json" }));
}
